class eventConfig {
  static UNAUTHORIZED = 'UNAUTHORIZED_EVENT';
  
 }

module.exports = eventConfig;